import axios from 'axios'
import { getNewStoreData } from 'services/util'

const awsBackendClient = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_HOST,
})

awsBackendClient.interceptors.request.use(config => {
  const { externalId } = getNewStoreData()
  if (externalId) {
    config.headers!['Authorization'] = `Bearer ${externalId}`
  }
  return config
})

export default awsBackendClient;